import {Card} from 'primereact/card';
import {TabPanel, TabView} from 'primereact/tabview';
import React from 'react';
import {BreadcrumbsItem} from 'react-breadcrumbs-dynamic';
import {withTranslation} from 'react-i18next';
import BaseListContainer from '../baseContainers/BaseListContainer';
import ActionButton from '../components/ActionButton';
import ActionLink from '../components/ActionLink';
import CriteriaDropdownComponent from '../components/criteria/CriteriaDropdownComponent';
import CriteriaTextComponent from '../components/criteria/CriteriaTextComponent';
import {CustomMessages} from '../components/CustomMessages';
import DivContainer from '../components/DivContainer';
import BlockUi from '../components/waitPanel/BlockUi';
import CardUserService from '../services/CardUserService';
import CardUnauthorizeDialog from './CardUnauthorizeDialog';

class MobileUserListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new CardUserService());
        this.state = {
            list: [],
            selectedList: [],
            selectAll: false,
            loading: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            filters: {},
            statusOpt: [],
            roleOpt: [],
            all: {
                content: [],
                totalElements: 0,
            },
            drivers: {
                content: [],
                totalElements: 0,
            },
            admins: {
                content: [],
                totalElements: 0,
            },
        };
        this.handleOpenDialog = this.handleOpenDialog.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.cardsTemplate = this.cardsTemplate.bind(this);
        this.handleBackOffAuth = this.handleBackOffAuth.bind(this);
        this.onAfterGetList = this.onAfterGetList.bind(this);
        this.timeoutHandler = undefined;
    }

    getDataKey() {
        return 'phoneNumber';
    }

    getListTitle() {
        return 'cards.userlistTitle';
    }

    updateSearchCriteria(criteria) {
        return {
            dateFrom: criteria.dateFrom,
            dateTo: criteria.dateTo,
            query: criteria.query,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        return {
            dateFrom: '',
            dateTo: '',
            query: '',
            firstResult: 0,
            maxResults: 10,
            sortField: 'clientAccount.customer.phoneNumber',
            sortAsc: true,
        };
    }

    initializeFromBackend() {
        const {t} = this.props;
        this.enumService
            .getEnumList('AccountRole', t)
            .then((roleOpt) =>
                this.setState({
                    roleOpt,
                })
            )
            .catch(() => {
                this.showErrorMessage(t('error.roleListError'));
            });
        this.enumService
            .getEnumList('MobileUserStatus', t)
            .then((statusOpt) =>
                this.setState({
                    statusOpt,
                })
            )
            .catch(() => {
                this.showErrorMessage(t('error.statusListError'));
            });
    }

    getCriteriaName() {
        return 'user-card-list-sc';
    }

    getContainerListName() {
        return 'user-card-list-container';
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderCriteria() {
        const {t} = this.props;
        return (
            <div className='row'>
                <CriteriaTextComponent
                    id='text-sc'
                    name='query'
                    colClass='col-xl-6 col-lg-6 col-md-6 col-sm-12'
                    value={this.state.criteria.query}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    label={''}
                    showLabel={false}
                    placeholder={t('cards.textFilter')}
                    iconSvg='ico_cards_magnifying_glass'
                    iconSize='cards-magnifying-glass'
                    global={true}
                    refreshFromBackend
                    timeoutHandler={this.refreshTable}
                />
                <CriteriaDropdownComponent
                    id='status-sc'
                    name='status'
                    showClear
                    label={t('cards.status')}
                    colClass='col-xl-3 col-lg-3 col-md-6 col-sm-12'
                    value={this.state.criteria.status}
                    options={this.state.statusOpt}
                    placeholder='Wszystkie'
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    optionLabel='label'
                    filterOptionValue='label'
                    refreshFromBackend
                />
            </div>
        );
    }

    globalFilterFields() {
        return ['phoneNumber', 'cardNumbers'];
    }

    prepareColumns() {
        const {t} = this.props;
        return [
            {
                field: 'phoneNumber',
                header: t('cards.phoneNumber'),
                sortable: true,
                sortField: 'clientAccount.customer.phoneNumber',
            },
            {
                field: 'accountRole',
                header: t('cards.roleName'),
                sortable: true,
                body: this.enumTemplate.bind(this, 'AccountRole', 'accountRole'),
                sortField: 'roleType',
            },
            {
                field: 'status',
                header: t('cards.status'),
                sortable: true,
                body: this.enumTemplate.bind(this, 'MobileUserStatus', 'status'),
                sortField: 'clientAccount.clientStatus',
            },
            {field: 'cardNumbers', header: t('cards.cards'), body: this.cardsTemplate},
            {
                key: 'actions',
                header: t('list.actions'),
                body: this.actionTemplate,
                className: 'table-column-action',
            },
        ];
    }

    cardsTemplate(rowData) {
        const {t} = this.props;
        if (rowData && rowData.cardNumbers) {
            const sliced = rowData.cardNumbers.length > 3 ? rowData.cardNumbers.slice(0, 3) : rowData.cardNumbers;
            let joined = sliced.join(',');
            if (rowData.cardNumbers.length > 3) {
                joined += `... (${rowData.cardNumbers.length - 3} ${t('cards.more')})`;
            }
            return joined;
        }
        return '';
    }

    prepareHeaderItems() {
        return this.isUserInRole('ROLE_FLEET') ? [{type: 'LABEL', className: 'float-left'}] : [];
    }

    handleOpenRow(rowData, e) {
        if (e) {
            e.preventDefault();
        }

        this.setState({dialogVisibile: true, ids: [rowData.petraId], element: rowData, dialogViewMode: 'EDIT'});
    }

    handleOpenDialog(e) {
        if (e) {
            e.preventDefault();
        }
        const {selectedList} = this.state;
        this.setState({
            dialogVisibile: true,
            selectedList: selectedList,
            element: selectedList[selectedList.length - 1],
            dialogViewMode: 'EDIT',
        });
    }

    handleCloseDialog(a, callback) {
        this.setState({dialogVisibile: false, ids: [], phoneNumbers: []}, () => {
            if (callback) callback();
        });
    }

    handleBackOffAuth() {
        this.setState({dialogVisibile: true});
    }

    render() {
        const {t} = this.props;
        return (
            <div className='card-list-container'>
                {this.state.dialogVisibile ? (
                    <CardUnauthorizeDialog
                        selectedList={this.state.selectedList}
                        onHide={(e) => this.handleCloseDialog(e)}
                        visible={this.state.dialogVisibile}
                        viewMode={this.state.dialogViewMode}
                        afterSave={(e) =>
                            this.handleCloseDialog(e, () => {
                                this.readMessage();
                                this.refreshTable();
                            })
                        }
                        blockUi={this.blockUi}
                        unblockUi={this.unblockUi}
                        _isMounted={this._isMounted}
                    />
                ) : null}
                <BreadcrumbsItem to='/card-list'>{t('cards.listName')}</BreadcrumbsItem>
                {this.renderAddToTrustedDevicesDialog()}
                {this.renderView()}
            </div>
        );
    }

    renderView() {
        const {t} = this.props;
        return (
            <DivContainer colClass=''>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} rendered={!this.props.embedded} />
                <BlockUi
                    tag='div'
                    blocking={this.state.blocking || this.state.loading}
                    loader={this.loader}
                    rendered={!this.props.embedded}
                >
                    <Card className='list-card'>
                        <DivContainer colClass='row'>{this.renderFilter()}</DivContainer>
                        <DivContainer colClass='row'>{this.renderHeader()}</DivContainer>
                        <TabView activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange} className='sub-tabview'>
                            <TabPanel header={`${t('cards.panelTitle.all')} (${this.state.all?.totalElements})`}>
                                {this.renderDataTable(this.prepareColumns(), this.state.all?.content, this.state.all?.totalElements)}
                            </TabPanel>
                            <TabPanel header={`${t('cards.panelTitle.driver')} (${this.state.drivers?.totalElements})`}>
                                {this.renderDataTable(
                                    this.prepareColumns(),
                                    this.state.drivers?.content,
                                    this.state.drivers?.totalElements
                                )}
                            </TabPanel>
                            <TabPanel header={`${t('cards.panelTitle.administrator')} (${this.state.admins?.totalElements})`}>
                                {this.renderDataTable(this.prepareColumns(), this.state.admins?.content, this.state.admins?.totalElements)}
                            </TabPanel>
                        </TabView>
                        <DivContainer colClass='row'>
                            <DivContainer colClass='p-card-header-minheight back-off'>
                                <ActionButton
                                    label={`${t('cards.cardUnauthorize')}${
                                        this.state.selectedList && this.state.selectedList.length > 0
                                            ? ` (${this.state.selectedList.length})`
                                            : ''
                                    }`}
                                    className={`float-left header-item`}
                                    handleClick={this.handleBackOffAuth}
                                    disabled={!this.state.selectedList || this.state.selectedList.length < 1 || !this.isUserHasPermission('PERMISSION_EDIT_FLEET_CARDS')}
                                    variant='back-off-auth fullred'
                                    key={'back-off-button'}
                                />
                            </DivContainer>
                        </DivContainer>
                    </Card>
                </BlockUi>
            </DivContainer>
        );
    }

    actionTemplate(rowData) {
        const {detailUrl, t} = this.props;
        const href = `${detailUrl}/${rowData?.phoneNumber}`;
        return (
            <ActionLink
                label={t('details.manageButton')}
                handleClick={this.handleGoToDetail.bind(this, href)}
                variant='blue'
                className='edit-blue-link'
                key={'view-button'}
            />
        );
    }

    getList() {
        const {criteria} = this.state;
        this.service
            .getList(criteria)
            .then((res) => {
                if (this._isMounted) {
                    this.setState(
                        {
                            drivers: {
                                content: this.updateListElements(res.drivers?.content),
                                totalElements: res.drivers?.totalElements,
                            },
                            admins: {
                                content: this.updateListElements(res.admins?.content),
                                totalElements: res.admins?.totalElements,
                            },
                            all: {content: this.updateListElements(res.all?.content), totalElements: res.all?.totalElements},
                            loading: false,
                            list: this.updateListElements(res.all?.content),
                            size: res.allList?.totalElements,
                        },
                        () => this.onAfterGetList(res)
                    );
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState(
                        {
                            drivers: {content: [], totalElements: 0},
                            admins: {content: [], totalElements: 0},
                            all: {content: [], totalElements: 0},
                            loading: false,
                        },
                        () => {
                            this.afterGetListError();
                        }
                    );
                }
            });
    }

    onAfterGetList(res) {
        this.props.unblockUi();
        this.props.onAfterGetList(res);
    }

    handleTabChange(e) {
        this.setState(
            (prevState) => ({
                activeIndex: e.index,
                selectAll: false,
                selectedList: [],
            }),
            () => {
                this.saveCookie(`user-cards-list-activeIndex`, this.state.activeIndex);
            }
        );
    }

    getContentFromResponse(response) {
        let activeIndex =  this.state.activeIndex !== null &&  this.state.activeIndex !== undefined ?  this.state.activeIndex  : 0;
        if (activeIndex >= 0) {
            switch (activeIndex) {
                case 0:
                    return response.all.content;
                case 1:
                    return response.drivers.content;
                case 2:
                    return response.admins.content;
                default:
                    return [];
            }
        }
        return [];
    }

    getTotalElements() {
        let activeIndex =  this.state.activeIndex !== null &&  this.state.activeIndex !== undefined ?  this.state.activeIndex  : 0;
        if (activeIndex >= 0) {
            switch (activeIndex) {
                case 0:
                    return this.state.all.totalElements;
                case 1:
                    return this.state.drivers.totalElements;
                case 2:
                    return this.state.admins.totalElements;
                default:
                    return [];
            }
        }else {return 0;}
        
    }
}

MobileUserListContainer.defaultProps = {
    lazy: true,
    disableSelection: false,
    selectionMode: 'multiple',
    detailUrl: '#/user-details',
};

MobileUserListContainer.propTypes = {};

export default withTranslation()(MobileUserListContainer);
